import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UploadImageButtonComponent } from '../upload-image-button/upload-image-button.component';
import { CameraSource } from '@capacitor/camera';
import { ImageUtil } from "@qid/core";
import { IonIcon, IonSpinner } from '@ionic/angular/standalone';
import { SexyModule } from '@qid/sexy';
import { Platform } from '@ionic/angular/standalone';

/** Initials circle: dark = dark fill + light text; light = light fill + dark text. */
export type AvatarRoundVariant = 'light' | 'dark';

@Component({
  selector: 'avatar-round',
  templateUrl: './avatar-round.component.html',
  styleUrls: ['./avatar-round.component.scss'],
  standalone: true,
  imports: [
    IonIcon,
    IonSpinner,
    UploadImageButtonComponent,
    SexyModule
  ],
})
export class AvatarRoundComponent {
  @ViewChild('uploadImageButtonComponent')
  uploadImageButtonComponent: UploadImageButtonComponent;

  private defaultImageUrl = 'assets/imgs/user-image-placeholder.png';
  @Input() imageUrl;
  @Input() autoBase = true;
  @Input() size = 100;
  @Input() lock = false;
  @Input() bubbleSize = 40;
  @Input() isEditMode: boolean = false;
  @Input() onImageAction: any;
  @Input() title: string;
  @Input() bubbleFilled: boolean = false;
  /** Initials appearance when no image: `dark` (default) = dark bg + light text; `light` = light bg + dark text. */
  @Input() variant: AvatarRoundVariant = 'dark';
  @Output() onBubbleClick = new EventEmitter();
  @Output() onImage = new EventEmitter();
  isOnAction: boolean = false;

  constructor(private platform: Platform) {
  }

  get initialsSxBackground(): string {
    return this.variant === 'light' ? 'light' : 'dark';
  }

  getBubbleTop() {
    return this.size - this.bubbleSize / 2;
  }

  getBubbleLeft() {
    return this.size / 2 - this.bubbleSize / 2;
  }

  onBubbleClicked() {
    this.onBubbleClick.emit();
  }

  onCameraClicked() {
    if (this.platform.is('desktop')) {
      this.uploadImageButtonComponent.upload(CameraSource.Photos);
      return;
    }

    this.uploadImageButtonComponent.upload(CameraSource.Prompt);
  }

  async onImageLoad(file: any) {
    this.isOnAction = true;
    try {
      await this.onImageAction(file);
      this.isOnAction = false;
    } catch (e) {
      this.isOnAction = false;
      console.error(e);
    }
  }

  getUrl() {
    if (!this.imageUrl || this.imageUrl.length < 1) {
      return this.defaultImageUrl;
    }
    if (!this.autoBase) {
      return this.imageUrl;
    }
    return ImageUtil.getImageSource(this.imageUrl);
  }

  getInitials(title: string) {
    if (!title) {
      return null;
    }
    let parts = title.split(' ');
    return parts.length > 1
      ? parts[0].charAt(0) + parts[1].charAt(0)
      : parts[0].charAt(0);
  }

  getInitialsFontSize() {
    return +this.size - this.size * 0.6 + 'px';
  }

}
